import { Flex, BKJButton } from '@bookjane2/bookjane-design-library';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import {
  CommunityName,
  LabelText,
  MainTitle,
} from 'modals/ShiftModal/src/views/DetailView/DetailView.styled';
import { SummaryInfo } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/SummaryInfo';
import { SectionDivider } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/SendToAgenciesSummaryView.styled';
import { FC, Fragment, MouseEventHandler } from 'react';
import { InfoSection } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.styled';
import { JaneAvatar } from 'components/BKJJaneAvatar';
import { useFetchAgencyTeamMemberByIdDataContext } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/FetchAgencyTeamMemberById.data.context';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import {
  JaneInfoAgencyName,
  JaneInfoName,
} from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/views/AssignToAgencyTeamMemberSummaryView/AssignToAgencyTeamMemberSummaryView.styled';
import { useAssignToAgencyTeamMemberFormContext } from 'modals/ShiftModal/src/views/AssignToAgencyTeamMemberView/contexts/AssignToAgencyTeamMemberView.form.context';
import { useTranslation } from 'hooks/useTranslation';

export const AssignToAgencyTeamMemberSummaryViewComponent: FC = () => {
  const { data: janeInfo } = useFetchAgencyTeamMemberByIdDataContext();
  const { data: orderInfo } = useShiftModalDataContext();
  const order = orderInfo?.order;
  const { isSubmitting, isDisabled, onSubmit } = useAssignToAgencyTeamMemberFormContext();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Flex flexDirection="column" padding="40px 32px 0px 32px" gap="22.5px" height="100%">
        <MainTitle>{t('shift_modal:CONFIRM_SHIFT_ASSIGNMENT')}</MainTitle>
        <CommunityName>
          {order?.subFacilityAddress?.name
            ? order?.subFacilityAddress?.name
            : order?.community.name}
        </CommunityName>
        <SummaryInfo />
        <SectionDivider variant="Thin" />
        <Flex flexDirection="column" gap="8px">
          <LabelText>{t('shift_modal:TEAM_MEMBER')}</LabelText>
          <InfoSection gap="20px" alignItems="center">
            <JaneAvatar
              status="pending"
              url={janeInfo?.fetchJane?.avatarUrls.origin}
              pendingSignup={janeInfo?.fetchJane?.pendingSignup}
            />
            <Flex flexDirection="column">
              <JaneInfoName>{`${janeInfo?.fetchJane?.firstName} ${janeInfo?.fetchJane?.lastName}`}</JaneInfoName>
              <JaneInfoAgencyName>
                {janeInfo?.fetchJane?.agencyCommunity?.agency.name}
              </JaneInfoAgencyName>
            </Flex>
          </InfoSection>
        </Flex>
      </Flex>
      <BKJSideModalFooter justifyContent="end">
        <BKJButton
          width="180px"
          variant="PurpleSolid"
          onClick={onSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
          disabled={isDisabled || isSubmitting}
        >
          {t('shift_modal:CONFIRM')}
        </BKJButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};
